import PropTypes from 'prop-types';

const sharedProps = {
  accountManagerEmail: PropTypes.string,
  clearSubmissionAttachments: PropTypes.func.isRequired,
  dba: PropTypes.string,
  failedUploads: PropTypes.array.isRequired,
  hideModal: PropTypes.func.isRequired,
  label: PropTypes.string,
  leadId: PropTypes.string,
  postSubmissionAttachments: PropTypes.func.isRequired,
  resetForm: PropTypes.func.isRequired,
  showModal: PropTypes.func.isRequired,
  step: PropTypes.number.isRequired,
  submission: PropTypes.object.isRequired,
  submissionInfo: PropTypes.object,
  submissionInfoActions: PropTypes.object
};

export default sharedProps;
